// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"PlayersPage_toolbar__2d3mN","add":"PlayersPage_add__1qu7L","table":"PlayersPage_table__1JwVZ"};